<template>
  <div class="container-fluid add-product">
    <h1>Add new product</h1>
    <div class="alert alert-danger" role="alert" v-if="errors.length > 0">
      <p v-for="(error, index) in errors" :key="index">{{ error }}</p>
    </div>
    <div v-if="addedSuccessfully">
      <div class="alert alert-success" role="alert">
        <p>Product addded successfully</p>
      </div>
      <button class="btn btn-primary" @click="addAnother">Add more</button>
    </div>
    <b-form v-else>
      <div class="row">
        <div class="col-md-6">
          <b-form-group id="input-group-1">
            <b-form-input
              id="input-1"
              v-model="product.title"
              type="text"
              maxlength="200"
              required
              @input="validateForm"
              placeholder="Product title"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-2">
            <b-form-input
              id="input-2"
              v-model="product.title_en"
              type="text"
              maxlength="200"
              required
              @input="validateForm"
              placeholder="Product title (en)"
            ></b-form-input>
          </b-form-group>
        </div>
        <!-- <div class="col-md-6" v-if="product.selected_cat && product.selected_cat.stock_type === 'fabric'"> -->
        <div class="col-md-6">
          <b-form-group id="input-group-3">
            <b-form-input
              id="input-3"
              v-model="product.subTitle"
              type="text"
              maxlength="400"
              required
              placeholder="Product description"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-4">
            <b-form-input
              id="input-4"
              v-model="product.subTitle_en"
              type="text"
              maxlength="400"
              required
              placeholder="Product description (en)"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="add-product__data">
        <div class="row">
          <div class="col-md-9">
            <div class="add-product__details">
              <header>
                <h2>Product Data</h2>
                <div class="add-product__details__category">
                  <p>Select Product Category:</p>
                  <select
                    class="
                      modified-dropdown
                      custom-select
                      form-control
                      add-product__details__select
                    "
                    v-model="product.selected_cat"
                  >
                    <option
                      v-for="category in categories"
                      :key="category.categoryId"
                      :value="category"
                    >
                      {{ category.filterTitle }}
                    </option>
                  </select>
                  <select
                    class="
                      modified-dropdown
                      custom-select
                      form-control
                      add-product__details__select
                    "
                    v-model="product.selected_sub"
                    v-if="product.selected_cat"
                  >
                    <option
                      v-for="category in product.selected_cat.subCategory"
                      :key="category.categoryId"
                      :value="category"
                    >
                      {{ category.name }}
                    </option>
                  </select>
                </div>
                <div class="add-product__details__checks form-group">
                  <b-form-checkbox
                    v-model="product.best_seller"
                    name="check-button"
                    switch
                    >Best Seller</b-form-checkbox
                  >
                  <b-form-checkbox
                    v-model="product.recommended"
                    name="check-button"
                    switch
                    >Recommended</b-form-checkbox
                  >
                  <b-form-checkbox
                    v-model="product.latest"
                    name="check-button"
                    switch
                    >Latest</b-form-checkbox
                  >
                </div>
              </header>
              <main>
                <aside>
                  <ul>
                    <li
                      @click="showFormPart(1)"
                      :class="[current_form === 1 ? 'active' : '']"
                    >
                      <i class="fas fa-wrench" aria-hidden></i>
                      General
                    </li>
                    <li
                      @click="showFormPart(2)"
                      :class="[current_form === 2 ? 'active' : '']"
                    >
                      <i class="fas fa-paste" aria-hidden></i>
                      Inventory
                    </li>
                    <li
                      @click="showFormPart(3)"
                      :class="[current_form === 3 ? 'active' : '']"
                      v-if="
                        product.selected_cat &&
                        product.selected_cat.stock_type === 'fabric'
                      "
                    >
                      <i class="fas fa-link" aria-hidden></i>
                      Customs
                    </li>
                    <li
                      @click="showFormPart(4)"
                      :class="[current_form === 4 ? 'active' : '']"
                      v-if="
                        product.selected_cat &&
                        product.selected_cat.stock_type === 'fabric'
                      "
                    >
                      <i class="fas fa-tshirt" aria-hidden></i>
                      Fabrics
                    </li>
                    <!-- {<li
                      @click="showFormPart(5)"
                      :class="[current_form === 5 ? 'active' : '' ]"
                      v-if="product.selected_cat && product.selected_cat.stock_type === 'fabric'"
                    >
                      <i class="fas fa-tshirt" aria-hidden></i>
                      Fabric Stock
                    </li>}-->
                  </ul>
                </aside>
                <div class="form-parts">
                  <div v-show="current_form === 1" class="form-parts__part">
                    <div
                      class="row"
                      v-show="
                        product.selected_cat &&
                        product.selected_cat.stock_type === 'fabric'
                      "
                    ></div>
                    <div
                      class="row"
                      v-show="
                        product.selected_cat &&
                        product.selected_cat.stock_type === 'fabric'
                      "
                    >
                      <b-form-group class="col-md-6" label="Type">
                        <b-form-input
                          v-model="product.type"
                          type="text"
                          maxlength="200"
                          label="type"
                          required
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group class="col-md-6" label="Type (en)">
                        <b-form-input
                          v-model="product.type_en"
                          type="text"
                          maxlength="200"
                          label="type"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div
                      class="row"
                      v-show="
                        product.selected_cat &&
                        product.selected_cat.stock_type === 'fabric'
                      "
                    >
                      <b-form-group class="col-md-6" label="Season">
                        <b-form-input
                          v-model="product.season"
                          type="text"
                          maxlength="200"
                          label="type"
                          required
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group class="col-md-6" label="Season (en)">
                        <b-form-input
                          v-model="product.season_en"
                          type="text"
                          maxlength="200"
                          label="type"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="row">
                      <b-form-group class="col-md-8" label="Price (SR)">
                        <b-form-input
                          v-model.number="product.price"
                          type="number"
                          maxlength="10"
                          label="type"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="row">
                      <b-form-group class="col-md-8" label="Sale Price (SR)">
                        <b-form-input
                          v-model.number="product.price_sales"
                          type="number"
                          maxlength="10"
                          label="type"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div
                      v-show="
                        product.selected_cat &&
                        product.selected_cat.stock_type === 'fabrics'
                      "
                    >
                      <div class="form-group">
                        <div
                          class="row"
                          v-for="(input, k) in product.winterCollectionSizes"
                          :key="k"
                        >
                          <b-form-group class="col-md-3" label="Size">
                            <select
                              class="form-control"
                              v-model="input.size"
                              required
                            >
                              <option
                                v-for="size in winterCollectionSizes"
                                :key="size.id"
                                :value="size.id"
                              >
                                {{ size.name_en }}
                              </option>
                            </select>
                          </b-form-group>
                          <div class="col-md-12 text-right">
                            <span class="p-2">
                              <i
                                class="fas fa-minus-circle"
                                @click="removeWinterCollectionSize(k)"
                                v-show="
                                  k ||
                                  (!k &&
                                    product.winterCollectionSizes.length > 1)
                                "
                                >Remove</i
                              >
                              <i
                                class="fas fa-plus-circle"
                                @click="addWinterCollectionSize(k)"
                                v-show="
                                  k == product.winterCollectionSizes.length - 1
                                "
                                >Add fields</i
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="current_form === 2" class="form-parts__part">
                    <div class="row">
                      <b-form-group class="col-md-8" label="SKU">
                        <b-form-input
                          v-model="product.sku"
                          type="text"
                          maxlength="200"
                          label="type"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div
                      class="row"
                      v-if="
                        product.selected_cat &&
                        (product.selected_cat.stock_type === 'product' || product.selected_cat.stock_type === 'fabrics')
                      "
                    >
                      <b-form-group class="col-md-8" label="Stock amount">
                        <b-form-input
                          v-model.number="product.stock"
                          type="number"
                          maxlength="200"
                          label="type"
                          required
                          v-if="
                            product.selected_sub &&
                            (product.selected_cat.slug === 'perfume5'  || product.selected_cat.stock_type === 'fabrics') ||
                            product.selected_cat.stock_type === 'product'"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div
                      class="card p-2"
                      v-if="
                        product.selected_cat &&
                        product.selected_sub &&
                        product.selected_cat.stock_type === 'product' &&
                        product.selected_cat.slug != 'perfume5'"
                    >
                      <div
                        class="form-group"
                        v-for="(input, k) in product.options"
                        :key="k"
                      >
                        <div class="row">
                          <div
                            class="col-md-3"
                            v-if="
                              product.selected_cat &&
                              product.selected_cat.filterTitle != 'كل الجزم'
                            "
                          >
                            <label>Color</label>
                            <select
                              class="form-control"
                              v-model="input.color"
                              required
                            >
                              <option
                                v-for="fabric in fabrics"
                                :key="fabric.id"
                                :value="fabric.id"
                              >
                                {{ fabric.name }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="col-md-3"
                            v-if="
                              product.selected_cat &&
                              product.selected_cat.filterTitle == 'كل الجزم'
                            "
                          >
                            <label>Shoes Color</label>
                            <select
                              class="form-control"
                              v-model="input.shoesColor"
                              required
                            >
                              <option
                                v-for="shoeColor in shoesColors"
                                :key="shoeColor.id"
                                :value="shoeColor.id"
                              >
                                {{ shoeColor.name_en }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-3">
                            <label>Size Name</label>
                            <select
                              class="form-control"
                              v-model="input.size"
                              required
                            >
                              <option
                                v-for="size in sizes"
                                :key="size.id"
                                :value="size.id"
                              >
                                {{ size.name_en }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="col-md-3"
                            v-if="
                              product.selected_cat &&
                              product.selected_cat.filterTitle == 'كل التصاميم'
                            "
                          >
                            <label>fabric</label>
                            <select
                              class="form-control"
                              v-model="input.fabric"
                              required
                            >
                              <option
                                v-for="fabric in fabrics_stocks"
                                :key="fabric.id"
                                :value="fabric.id"
                              >
                                {{ fabric.name_en }}
                              </option>
                            </select>
                          </div>

                          <div class="col-md-3">
                            <label> Quantity</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="input.quantity"
                              required
                            />
                          </div>
                          <div class="col-md-12 text-right">
                            <span class="p-2">
                              <i
                                class="fas fa-minus-circle"
                                @click="removeOption(k)"
                                v-show="k || (!k && product.options.length > 1)"
                                >Remove</i
                              >
                              <i
                                class="fas fa-plus-circle"
                                @click="addOption(k)"
                                v-show="k == product.options.length - 1"
                                >Add fields</i
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="current_form === 3" class="form-parts__part">
                    <div class="autocomplete-container container">
                      <div class="row">
                        <div class="col-md-8">
                          <div v-for="(acc, index) in accessories" :key="index">
                            <div v-if="acc.children.length">
                              <legend for="accessory-input">
                                {{ acc.category.name_en }}
                              </legend>
                              <div class="autocomplete-container__input">
                                <!-- <input
                              type="text"
                              maxlength="200"
                              name
                              class="form-control"
                              id="accessory-input"
                              min="0"
                              v-model="product.accessories"
                              @input="getOnInput('accessories')"
                            />-->
                                <select class="form-control" multiple>
                                  <option
                                    v-for="accessory in acc.children"
                                    :key="accessory.id"
                                    :value="accessory"
                                    @click="
                                      addAccessory(accessory, acc.category)
                                    "
                                  >
                                    {{ accessory.name }}
                                  </option>
                                </select>
                                <!-- <div
                              class="autocomplete-container__results"
                              v-if="accessories.length > 0"
                            >
                              <ul>
                                <li
                                  v-for="accessory in accessories"
                                  :key="accessory.id"
                                  @click="addAccessory(accessory)"
                                >{{accessory.name}}</li>
                              </ul>
                            </div>-->
                              </div>
                            </div>
                          </div>
                          <legend>Betana</legend>
                          <div class="autocomplete-container__input--betana">
                            <!-- <input
                              type="text"
                              maxlength="200"
                              name
                              class="form-control"
                              id="betana-input"
                              min="0"
                              v-model="product.betanas"
                              @input="getOnInput('betanas')"
                            />-->

                            <!-- <div class="autocomplete-container__results" v-if="betanas.length > 0">
                              <ul>
                                <li
                                  v-for="betana in betanas"
                                  :key="betana.id"
                                  @click="addBetana(betana)"
                                >{{betana.name}}</li>
                              </ul>
                            </div>-->
                            <select class="form-control" multiple>
                              <option
                                v-for="betana in betanas"
                                :key="betana.id"
                                :value="betana"
                                @click="addBetana(betana)"
                              >
                                {{ betana.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4 selected-items">
                          <div v-for="(acc, index) in accessories" :key="index">
                            <div v-if="acc.children.length">
                              <h3>Selected {{ acc.category.name_en }}</h3>

                              <div class="row">
                                <div
                                  class="col-sm-3"
                                  v-for="accessory in product.resultAccessories.filter(
                                    (i) => {
                                      return i.parent_id == acc.category.id;
                                    }
                                  )"
                                  :key="accessory.id"
                                >
                                  <div
                                    class="accessory-item"
                                    :class="{
                                      selected: isAccDefault(accessory.id),
                                    }"
                                    @click="
                                      changeDefaultAccessory(accessory.id)
                                    "
                                  >
                                    <!-- <span>{{accessory.name}}</span> -->
                                    <img
                                      :src="accessory.img"
                                      :alt="accessory.name"
                                    />
                                    <button
                                      class="
                                        btn btn-danger
                                        accessory-item__delete
                                      "
                                      @click.stop="
                                        deleteAccessory(accessory.id)
                                      "
                                    >
                                      X
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <h3>Selected Betanas</h3>

                          <div class="row">
                            <div
                              class="col-sm-3"
                              v-for="betana in product.resultBetanas"
                              :key="betana.id"
                            >
                              <div
                                class="accessory-item"
                                :class="{
                                  selected: betana.id == product.default_betana,
                                }"
                                @click="changeDefaultBetana(betana.id)"
                              >
                                <!-- <span>{{accessory.name}}</span> -->
                                <img :src="betana.img" :alt="betana.name" />
                                <button
                                  class="btn btn-danger accessory-item__delete"
                                  @click.stop="deleteBetana(betana.id)"
                                >
                                  X
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="autocomplete-container">
                      <div class="row">
                        <b-form-group class="col-md-8"></b-form-group>
                        <div class="col-md-4">
                          <div class="row"></div>
                        </div>
                      </div>
                    </div>-->
                  </div>
                  <div v-show="current_form === 4" class="form-parts__part">
                    <div class="row width-100">
                      <b-form-group class="col-12" label="Fabric Colors">
                        <select class="form-control" multiple>
                          <option
                            v-for="fabric in fabrics"
                            :key="fabric.id"
                            :value="fabric"
                            @click="addFabric(fabric)"
                          >
                            {{ fabric.name }}
                          </option>
                        </select>
                      </b-form-group>
                      <div class="col-12">
                        <h3>Selected Fabrics</h3>
                        <p>and choose default one</p>
                        <div style="display: inline-flex; flex-flow: wrap">
                          <div
                            v-for="fabric in product.selected_fabrics"
                            :key="fabric.id"
                            class="d-flex fabric-item"
                            style="margin: 0.5rem; width: 45%"
                          >
                            <p style="margin: 0.5rem">{{ fabric.name }}</p>
                            <input
                              style="width: fit-content; margin: 0.5rem"
                              type="checkbox"
                              :checked="fabric.id === product.default_fabric"
                              @input="checkSelectedFabric($event, fabric.id)"
                            />
                            <UploadImage
                              style="margin: 0.5rem"
                              :metaId="fabric.id"
                              @addFabricImg="addFabricImg"
                            ></UploadImage>
                            <button
                              style="margin: 0.5rem"
                              class="
                                btn btn-danger
                                fabric-item__delete
                                align-self-start
                              "
                              @click.stop="deleteFabric(fabric.id)"
                            >
                              X
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </div>
          <div class="col-md-3 add-product__images">
            <strong>
              Please use an image that has an aspect ratio of
              <br />
              <br />
              {{
                product.selected_cat &&
                product.selected_cat.stock_type == "fabric"
                  ? "1 : 1.27 (W : H) - Example: 350x520"
                  : "1 : 1 (W : H) - Example: 350x350"
              }}
              <br />
              <br />
              Ignoring this may cause distortion of the image on the website
            </strong>
            <br />
            <button class="btn btn-primary" v-if="loadingAddProduct" disabled>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Loading
            </button>
            <b-button type="submit" @click="onSubmit" variant="primary" v-else
              >Submit</b-button
            >
            <b-card header="Product image" class="mt-2">
              <input type="file" accept="image/*" id="product_image" />
            </b-card>

            <b-card
              header="Product yaka image"
              class="mt-2"
              v-show="
                product.selected_cat &&
                (product.selected_cat.stock_type === 'fabric' || product.selected_cat.stock_type === 'fabrics')
              "
            >
              <input type="file" accept="image/*" id="product_yaka_image" />
            </b-card>
            <b-card
              header="Product zarzour image"
              class="mt-2"
              v-show="
                product.selected_cat &&
                (product.selected_cat.stock_type === 'fabric' || product.selected_cat.stock_type === 'fabrics')
              "
            >
              <input type="file" accept="image/*" id="product_zarzour_image" />
            </b-card>

            <b-card
              header="Product akmam image"
              class="mt-2"
              v-show="
                product.selected_cat &&
                (product.selected_cat.stock_type === 'fabric' || product.selected_cat.stock_type === 'fabrics')
              "
            >
              <input type="file" accept="image/*" id="product_akmam_image" />
            </b-card>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
// import { globalStore } from "../../main.js";
import axios from "axios";
import { getCookie } from "../../cookie.js";
import { herokuUrl } from "../../apiConfig";
import UploadImage from "./UploadImage.vue";
import logOut from "../../scripts/utils";

export default {
  data() {
    return {
      errors: [],
      loading: false,
      loadingAddProduct: false,
      sizes: [],
      winterCollectionSizes: [],
      fabrics_stocks: [],
      shoesColors: [],
      product: {
        title: "",
        title_en: "",
        subTitle: "",
        subTitle_en: "",
        type: "",
        type_en: "",
        season: "",
        season_en: "",
        price: 0,
        price_sales: 0,
        name: "",
        sku: "",
        selected_cat: null,
        selected_sub: null,
        best_seller: false,
        recommended: false,
        latest: false,
        accessories: "",
        betanas: "",
        resultAccessories: [],
        resultBetanas: [],
        default_accessory: null,
        default_betana: null,
        stock: 0,
        selected_fabrics: [],
        default_fabric: null,
        options: [
          {
            color: "",
            size: "",
            fabric: "",
            shoesColor: "",
            quantity: "",
          },
        ],
        winterCollectionSizes: [{ size: "" }],
      },
      current_form: 1,
      categories: [],
      fabrics: [],
      form_parts: [
        { content: "General", fa: "fa-wrench" },
        { content: "Inventory", fa: "fa-paste" },
        { content: "Customs", fa: "fa-link" },
        { content: "Fabrics", fa: "fa-tshirt" },
      ],
      form_attempt: false,
      accessories: [],
      betanas: [],
      addedSuccessfully: false,
      calssificationsOfAccessories: {},
    };
  },
  components: {
    UploadImage,
  },

  methods: {
    getfabrics: function () {
      this.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/fabrics`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res);
          this.fabrics_stocks = res[0].data["fabrics"];
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getsizes: function () {
      this.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/sizes`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res);
          this.sizes = res[0].data["sizes"];
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWinterCollectionSizes: function () {
      this.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/winter_collection_sizes`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res);
          this.winterCollectionSizes = res[0].data["sizes"];
          this.formState.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getShoesColors: function () {
      this.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/shoes_colors`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res[0].data["colors"]);
          this.shoesColors = res[0].data["colors"];
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addOption() {
      this.product.options.push({
        color: "",
        size: "",
        fabric: "",
        shoesColor: "",
        quantity: "",
      });
      console.log(this.product.options);
    },

    removeOption(index) {
      this.product.options.splice(index, 1);
    },
    addWinterCollectionSize() {
      this.product.winterCollectionSizes.push({ size: "" });
      console.log(this.product.winterCollectionSizes);
    },

    removeWinterCollectionSize(index) {
      this.product.winterCollectionSizes.splice(index, 1);
    },

    showFormPart(part) {
      this.current_form = part;
      // if (part === 4) {
      //   this.getColors();
      // }
    },
    validateForm() {},
    getCategories() {
      axios
        .post(`${herokuUrl}/dashboard/categories`)
        .then((response) => {
          if (response.status) {
            this.categories = response.data.categories;
            console.log(this.categories);
          } else {
            this.error = response.data.message;
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
    getColors() {
      axios
        .post(`${herokuUrl}/dashboard/colors`)
        .then((response) => {
          console.log("colorsssssssss", response.data.colors);
          if (response.data.status) {
            this.loading = false;
            this.fabrics = response.data.colors;
          } else {
            this.loading = false;
            this.error = response.data.message;
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.loading = false;
            this.error = err;
          }
        });
    },

    checkSelectedFabric(event, id) {
      /* eslint-disable no-console */
      // console.log(event, id)
      this.product.default_fabric = id;
    },
    getOnInput(type) {
      // if (this.product[type].length > 0) {
      axios
        .post(
          `${herokuUrl}/dashboard/selectableProducts/${type}`,
          { language: 1 },
          {
            headers: { Authorization: getCookie("user") },
          }
        )
        .then((response) => {
          if (response.data.status) {
            this[type] = response.data[type];
          } else {
            this.errors.push("error in loading");
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            logOut();
          } else {
            this.error = error;
          }
        });
      // // } else {
      //   this[type] = [];
      // }
    },
    isAccDefault(id) {
      let classifications = Object.keys(this.calssificationsOfAccessories);
      let itsClassification = null;
      let foundIndex = -1;
      for (let m = 0; m < classifications.length; m++) {
        let i = classifications[m];
        foundIndex = this.calssificationsOfAccessories[String(i)].arr.findIndex(
          (j) => {
            return j.id == id;
          }
        );
        if (foundIndex >= 0) {
          itsClassification = String(i);
          break;
        }
      }
      return (
        this.calssificationsOfAccessories[itsClassification].arr[foundIndex]
          .id ==
        this.calssificationsOfAccessories[itsClassification].default_accessory
      );
    },
    addAccessory(accessory, categoryOfAcc) {
      this.calssificationsOfAccessories[categoryOfAcc.name_en]
        ? null
        : (this.calssificationsOfAccessories[categoryOfAcc.name_en] = {
            arr: [],
            default_accessory: null,
          });
      if (!this.product.resultAccessories.find((i) => i.id === accessory.id)) {
        if (this.product.resultAccessories.length == 0) {
          this.product.default_accessory = accessory.id;
        }

        if (
          this.calssificationsOfAccessories[categoryOfAcc.name_en].arr.length ==
          0
        ) {
          this.calssificationsOfAccessories[
            categoryOfAcc.name_en
          ].default_accessory = accessory.id;
        }
        this.calssificationsOfAccessories[categoryOfAcc.name_en].arr.push(
          accessory
        );
        this.calssificationsOfAccessories = {
          ...this.calssificationsOfAccessories,
        };

        this.product.resultAccessories.push(accessory);
      }
    },
    addBetana(betana) {
      if (!this.product.resultBetanas.find((i) => i.id === betana.id)) {
        if (this.product.resultBetanas.length == 0) {
          this.product.default_betana = betana.id;
        }
        this.product.resultBetanas.push(betana);
      }
    },
    deleteAccessory(id) {
      this.product.resultAccessories.splice(
        this.product.resultAccessories.findIndex((i) => i.id === id),
        1
      );

      let classifications = Object.keys(this.calssificationsOfAccessories);
      let itsClassification = null;
      let foundIndex = -1;
      for (let m = 0; m < classifications.length; m++) {
        let i = classifications[m];
        foundIndex = this.calssificationsOfAccessories[String(i)].arr.findIndex(
          (j) => {
            return j.id == id;
          }
        );
        if (foundIndex >= 0) {
          itsClassification = String(i);
          break;
        }
      }
      this.calssificationsOfAccessories[itsClassification].arr.splice(
        foundIndex,
        1
      );

      if (
        this.calssificationsOfAccessories[itsClassification]
          .default_accessory === id
      ) {
        this.calssificationsOfAccessories[itsClassification].arr.length
          ? (this.calssificationsOfAccessories[
              itsClassification
            ].default_accessory =
              this.calssificationsOfAccessories[itsClassification].arr[0].id)
          : (this.calssificationsOfAccessories[
              itsClassification
            ].default_accessory = null);
      }
      this.calssificationsOfAccessories = {
        ...this.calssificationsOfAccessories,
      };

      if (this.product.default_accessory === id) {
        this.product.default_accessory = this.product.resultAccessories[0].id;
      }
    },
    deleteBetana(id) {
      this.product.resultBetanas.splice(
        this.product.resultBetanas.findIndex((i) => i.id === id),
        1
      );
      if (this.product.default_betana === id) {
        this.product.default_betana = this.product.resultBetanas[0].id;
      }
    },
    deleteFabric(id) {
      this.product.selected_fabrics.splice(
        this.product.selected_fabrics.findIndex((i) => i.id === id),
        1
      );
      if (this.product.default_fabric === id) {
        this.product.default_fabric = this.product.selected_fabrics[0].id;
      }
    },
    changeDefaultAccessory(id) {
      console.log("calles");
      let classifications = Object.keys(this.calssificationsOfAccessories);
      let itsClassification = null;
      let foundIndex = -1;
      for (let m = 0; m < classifications.length; m++) {
        let i = classifications[m];
        foundIndex = this.calssificationsOfAccessories[String(i)].arr.findIndex(
          (j) => {
            return j.id == id;
          }
        );
        if (foundIndex >= 0) {
          itsClassification = String(i);
          break;
        }
      }
      this.calssificationsOfAccessories[itsClassification].default_accessory =
        id;
      this.calssificationsOfAccessories = {
        ...this.calssificationsOfAccessories,
      };
      // this.product.default_accessory = id;
    },
    changeDefaultBetana(id) {
      this.product.default_betana = id;
    },
    addFabric(fabric) {
      if (!this.product.selected_fabrics.find((i) => i.id === fabric.id)) {
        this.product.selected_fabrics.push(fabric);
        if (
          this.product.selected_fabrics[0].id &&
          !this.product.default_fabric
        ) {
          this.product.default_fabric = this.product.selected_fabrics[0].id;
          console.log(this.product.selected_fabrics[0].id);
        }
      }
    },
    addFabricImg(img, fabricId) {
      console.log("i am adding an image");
      this.product.selected_fabrics.find((i) => i.id === fabricId)["img"] = img;
    },
    setAccessorySearch() {
      this.accessories = [];
    },
    // selectCat(id) {
    //   this.product.selected_cat = id;
    // },
    compress(imageElem, bodyFormDataObj, keyName, checksObj) {
      const width = 350;
      const height =
        this.product.selected_cat &&
        this.product.selected_cat.stock_type == "fabric"
          ? 520
          : 350;
      const fileName = imageElem.files[0].name;
      const reader = new FileReader();
      console.log(imageElem.files[0]);
      reader.readAsDataURL(imageElem.files[0]);
      return (reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        (img.onload = () => {
          const elem = document.createElement("canvas");
          elem.width = width;
          elem.height = height;
          const ctx = elem.getContext("2d");
          // img.width and img.height will contain the original dimensions
          ctx.drawImage(img, 0, 0, width, height);
          ctx.canvas.toBlob(
            (blob) => {
              const file = new File([blob], fileName, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              bodyFormDataObj.append(keyName, file);
              checksObj[0] = true;
            },
            "image/jpeg",
            1
          );
        }),
          (reader.onerror = (error) => console.log(error));
      });
    },
    onSubmit(e) {
      e.preventDefault();
      console.log(
        this.product.selected_fabrics.map((i) => ({
          id: i.id,
          default: i.id == this.product.default_fabric,
          img: i.img,
        }))
      );
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type == "product" && 
        this.product.options && this.product.options.length > 0 && this.product.options[0].quantity != "" && this.product.options[0].quantity > 0
      ) {
        this.product.options.map((i) => {
          this.product.stock += Number(i.quantity);
        });
      }

      this.errors = [];
      var bodyFormData = new FormData();
      if (!this.product.title) {
        this.errors.push("Please add product title");
      }
      if (
        this.product.title &&
        (this.product.title.length > 50 || this.product.title.length < 3)
      ) {
        this.errors.push(
          "Product Title should be between 3 and 50 characters."
        );
      }
      if (!this.product.title_en) {
        this.errors.push("Please add product title (en)");
      }
      if (
        this.product.title_en &&
        (this.product.title_en.length > 50 || this.product.title_en.length < 3)
      ) {
        this.errors.push(
          "Product title(EN) should be between 3 and 50 characters."
        );
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        !this.product.subTitle
      ) {
        this.errors.push("Please add product description");
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        this.product.subTitle &&
        (this.product.subTitle.length > 350 || this.product.subTitle.length < 3)
      ) {
        this.errors.push(
          "Product description should be between 3 and 350 characters."
        );
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        !this.product.subTitle_en
      ) {
        this.errors.push("Please add product description (en)");
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        this.product.subTitle_en &&
        (this.product.subTitle_en.length > 350 ||
          this.product.subTitle_en.length < 3)
      ) {
        this.errors.push(
          "Product description (en) should be between 3 and 350 characters"
        );
      }
      if (!this.product.price) {
        this.errors.push("Please add product price");
      }
      // if (!this.product.price_sales) {
      //     this.errors.push("Please add product price sale");
      // }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        !this.product.season
      ) {
        this.errors.push("Please add product season");
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        this.product.season &&
        (this.product.season.length > 50 || this.product.season.length < 3)
      ) {
        this.errors.push(
          "Product Season should be between 3 and 50 characters"
        );
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        !this.product.season_en
      ) {
        this.errors.push("Please add product season (en)");
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        this.product.season_en &&
        (this.product.season_en.length > 50 ||
          this.product.season_en.length < 3)
      ) {
        this.errors.push(
          "Product Season (EN) should be between 3 and 50 characters"
        );
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        !this.product.type
      ) {
        this.errors.push("Please add product type");
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        this.product.type &&
        (this.product.type.length > 50 || this.product.type.length < 3)
      ) {
        this.errors.push("Product Type should be between 3 and 50 characters");
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        !this.product.type_en
      ) {
        this.errors.push("Please add product type (en)");
      }
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        this.product.type_en &&
        (this.product.type_en.length > 50 || this.product.type_en.length < 3)
      ) {
        this.errors.push(
          "Product Type (EN) should be between 3 and 50 characters"
        );
      }
      if (!this.product.sku) {
        this.errors.push("Please add product sku");
      }
      if (!this.product.selected_cat) {
        this.errors.push("Please add product category");
      }
      if (!this.product.selected_sub) {
        this.errors.push("Plese add product subcategory");
      }

      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type == "product" &&
        this.product.stock == 0
      ) {
        this.errors.push("Please add Stock amount");
      }
      if (
        this.product.price_sales &&
        this.product.price &&
        this.product.price_sales > this.product.price
      ) {
        this.errors.push("Sale Price can't be more than original Price");
      }

      /* Set the discount's default value to "0" to avoid old value "null" issues with Sequelize */
      // if (this.product.price_sales && this.product.price_sales == 0) {

      //     this.errors.push("Sale Price can't be 0.. if you want no discount add price sale with same original price");
      // }

      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type === "fabric" &&
        ((this.product.selected_fabrics &&
          this.product.selected_fabrics.length < 1) ||
          !this.product.selected_fabrics)
      ) {
        this.errors.push("Please add a fabric to your product");
      }

      let file1 = document.getElementById("product_image").files[0];
      let file2 = document.getElementById("product_yaka_image").files[0];
      let file3 = document.getElementById("product_akmam_image").files[0];
      let file4 = document.getElementById("product_zarzour_image").files[0];

      if (!file1) this.errors.push("Plese add product image");
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type == "fabric" &&
        !file2
      )
        this.errors.push("Please add product yaka image");
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type == "fabric" &&
        !file3
      )
        this.errors.push("Please add product akmam image");
      if (
        this.product.selected_cat &&
        this.product.selected_cat.stock_type == "fabric" &&
        !file4
      )
        this.errors.push("Please add product zarzour image");

      // if fabric added, make sure image uploaded to them
      if (
        this.product.selected_fabrics.length > 0 &&
        !this.product.selected_fabrics.every((item) => item.img)
      )
        this.errors.push("Please add product image for every color");

      /* eslint-disable no-console */
      console.log(document.getElementById("product_yaka_image"));
      console.log(file3);
      console.log(file4);

      if (this.errors.length === 0) {
        bodyFormData.set("title", this.product.title);
        bodyFormData.set("title_en", this.product.title_en);
        bodyFormData.set("sub_title", this.product.subTitle);
        bodyFormData.set("sub_title_en", this.product.subTitle_en);
        bodyFormData.set("is_last", this.product.latest);
        bodyFormData.set("is_recommended", this.product.recommended);
        bodyFormData.set("is_best_seller", this.product.best_seller);
        this.product.selected_sub
          ? bodyFormData.set(
              "category_id",
              this.product.selected_sub.categoryId
            )
          : null;
        bodyFormData.set("price", this.product.price);
        bodyFormData.set("sale_price", this.product.price_sales);
        bodyFormData.set("season_en", this.product.season_en);
        bodyFormData.set("season", this.product.season);
        bodyFormData.set("sku", this.product.sku);
        bodyFormData.set("type_en", this.product.type_en);
        bodyFormData.set("type", this.product.type);
        // bodyFormData.set("stockAmount", this.product.stock);
        let checks = [];
        checks.push([false]);
        this.compress(
          document.getElementById("product_image"),
          bodyFormData,
          "product_image",
          checks[0]
        );
        if (file2) {
          checks.push([false]);
          this.compress(
            document.getElementById("product_yaka_image"),
            bodyFormData,
            "product_yaka_image",
            checks[checks.length - 1]
          );
        }
        if (file3) {
          checks.push([false]);
          this.compress(
            document.getElementById("product_akmam_image"),
            bodyFormData,
            "product_akmam_image",
            checks[checks.length - 1]
          );
        }
        if (file4) {
          checks.push([false]);
          this.compress(
            document.getElementById("product_zarzour_image"),
            bodyFormData,
            "product_zarzour_image",
            checks[checks.length - 1]
          );
        }
        // bodyFormData.append("product_image", file1);
        // bodyFormData.append("product_yaka_image", file2);
        // bodyFormData.append("product_akmam_image", file3);
        // bodyFormData.append("product_zarzour_image", file4);
        this.product.selected_fabrics.length > 0
          ? bodyFormData.append(
              "fabrics",
              JSON.stringify(
                this.product.selected_fabrics.map((i) => ({
                  id: i.id,
                  default: i.id == this.product.default_fabric,
                  img: i.img,
                }))
              )
            )
          : null;
        this.product.stock
          ? bodyFormData.append("stockAmount", this.product.stock)
          : null;
        this.product.resultAccessories.length > 0
          ? bodyFormData.append(
              "accessories",
              JSON.stringify(
                this.product.resultAccessories.map((i) => ({
                  id: i.id,
                  default: this.isAccDefault(i.id),
                }))
              )
            )
          : null;
        this.product.resultBetanas.length > 0
          ? bodyFormData.append(
              "betanas",
              JSON.stringify(
                this.product.resultBetanas.map((i) => ({
                  id: i.id,
                  default: i.id == this.product.default_betana,
                }))
              )
            )
          : null;
          if (this.product.options && this.product.options.length > 0 && this.product.options[0].quantity != "" && this.product.options[0].quantity > 0 ) {
          bodyFormData.append(
            "options_stock",
            JSON.stringify(
              this.product.options.map((i) => ({
                color: i.color,
                size: i.size,
                fabric: i.fabric,
                shoeColor: i.shoesColor,
                quantity: i.quantity,
              }))
            )
          );
        } else {
          bodyFormData.append("options_stock", JSON.stringify([]));
        }
        if (
          this.product.selected_cat &&
          this.product.selected_cat.stock_type == "fabrics" &&
          this.product.winterCollectionSizes.length > 0 &&
          this.product.winterCollectionSizes[0].size !== ""
        ) {
          bodyFormData.append(
            "winterCollectionSizes",
            JSON.stringify(this.product.winterCollectionSizes)
          );
        }
        console.log(bodyFormData);
        this.loadingAddProduct = true;
        let xbc = () => {
          let proceed = false;
          checks.forEach((check) => {
            check[0] ? (proceed = true) : (proceed = false);
          });
          if (proceed) {
            console.log("ready");
            return axios({
              method: "POST",
              url: `${herokuUrl}/dashboard/add-product`,
              data: bodyFormData,
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: getCookie("user"),
              },
            })
              .then((response) => {
                this.loadingAddProduct = false;
                console.log(response.data);
                if (response.data.status) {
                  this.addedSuccessfully = true;
                  this.product = {
                    title: "",
                    title_en: "",
                    subTitle: "",
                    subTitle_en: "",
                    type: "",
                    type_en: "",
                    season: "",
                    season_en: "",
                    price: null,
                    price_sales: 0,
                    name: "",
                    sku: "",
                    selected_cat: null,
                    selected_sub: null,
                    best_seller: false,
                    recommended: false,
                    latest: false,
                    accessories: "",
                    betanas: "",
                    resultAccessories: [],
                    resultBetanas: [],
                    default_accessory: null,
                    default_betana: null,
                    stock: 0,
                    selected_fabrics: [],
                    default_fabric: null,
                    options: [
                      {
                        color: "",
                        size: "",
                        fabric: "",
                        shoesColor: "",
                        quantity: "",
                      },
                    ],
                  };
                } else {
                  this.errors.push("For files, large file upload is forbidden");
                  if (response.data.error && response.data.error.errors)
                    this.errors.push(
                      ...response.data.error.errors.map((er) => er.message)
                    );
                }
              })
              .catch((err) => {
                if (err.response.status == 401) {
                  logOut();
                } else {
                  this.loadingAddProduct = false;
                  console.log(err);
                  this.errors.push(err);
                  this.errors.push("For files, large file upload is forbidden");
                }
              });
          }
          console.log("Not yet");
          setTimeout(xbc, 200);
        };
        xbc();
      }
    },
    addAnother() {
      this.product.title = "";
      this.product.title_en = "";
      this.product.subTitle = "";
      this.product.subTitle_en = "";
      this.product.type = "";
      this.product.type_en = "";
      this.product.season = "";
      this.product.season_en = "";
      this.product.price = 0;
      this.product.price_sales = 0;
      this.product.name = "";
      this.product.sku = "";
      this.product.selected_cat = null;
      this.product.selected_sub = null;
      this.product.best_seller = false;
      this.product.recommended = false;
      this.product.latest = false;
      this.product.accessories = "";
      this.product.betanas = "";
      this.product.resultAccessories = [];
      this.product.resultBetanas = [];
      this.product.default_accessory = null;
      this.product.default_betana = null;
      this.product.default_fabric = null;
      this.addedSuccessfully = false;
      this.errors = [];
      this.loading = false;
      this.loadingAddProduct = false;
      this.current_form = 1;
      this.categories = [];
      this.fabrics = [];
      this.form_parts = [
        { content: "General", fa: "fa-wrench" },
        { content: "Inventory", fa: "fa-paste" },
        { content: "Customs", fa: "fa-link" },
        { content: "Fabrics", fa: "fa-tshirt" },
      ];
      this.form_attempt = false;
      this.accessories = [];
      this.betanas = [];
      this.addedSuccessfully = false;
      this.calssificationsOfAccessories = {};
      this.getCategories();
      this.getOnInput("accessories");
      this.getOnInput("betanas");
    },
  },
  created() {
    this.getCategories();
    this.getOnInput("accessories");
    this.getOnInput("betanas");
    this.getColors();
    this.getfabrics();
    this.getsizes();
    this.getShoesColors();
    this.getWinterCollectionSizes();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/_global.scss";
.add-product {
  text-align: left !important;
  &__details {
    border: 1px solid #ccc;
    background: #fff;
    border-radius: 3px;
    header {
      // display: flex;
      // justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #ccc;
      padding: 10px;
    }
    &__category {
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      p {
        margin-bottom: 0;
      }
    }
    &__select {
      margin-left: 20px;
      width: 30%;
      height: 30px;
    }
    &__checks {
      display: flex;
      // flex: 2;
      .custom-control {
        margin-left: 10px;
      }
    }
    main {
      display: flex;
      aside {
        background: #fafafa;
        width: 15%;
        ul {
          padding: 0;
        }
        li {
          list-style: none;
          padding: 5px 10px;
          cursor: pointer;
          color: #5c8cb1;
          &:hover {
            background: #ededed;
            color: #abaaaf;
          }
        }
        .active {
          background: #ededed;
          color: #abaaaf;
        }
        li + li {
          border-top: 1px solid #ccc;
        }
      }
      .form-parts {
        flex: 1;
        border-left: 1px solid #ccc;
        &__part {
          padding: 10px;
        }
      }
    }
  }
  &__images {
    font-size: 14px !important;
  }
}
input {
  font-size: 16px;
  width: 100%;
}
.autocomplete-container {
  width: 100%;
  &__input {
    position: relative;
    z-index: 20;
    width: 100%;
    &--betana {
      position: relative;
      width: 100%;

      z-index: 15;
    }
  }
  &__results {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 22;
    ul {
      padding: 0;
      margin: 0;
      background: #fff;
      border: 1px solid #ccc;
    }
    li {
      list-style: none;
      padding: 5px;
      // opacity: 0.6;
      &:hover {
        background: #eee;
        cursor: pointer;
      }
    }
    li + li {
      border-top: 1px solid #ccc;
    }
  }
  .fabric-item__delete {
    height: 20p !important;
    font-size: 6px;
  }
  .accessory-item {
    // border: 1px solid #ccc;
    cursor: pointer;
    position: relative;

    img {
      width: 100%;
    }
    &__delete {
      width: 50%;
      font-size: 5px;
      position: absolute;
      left: 50%;
      top: 0;
      bottom: 50%;
      padding: 0;
      margin: 0;
    }
  }
  .selected-items {
    .row {
      margin-left: -5px;
      margin-right: -5px;
    }
    .col-sm-3 {
      padding-left: 5px;
      padding-right: 5px;
      margin-bottom: 5px;
    }
  }
  legend {
    border: none;
  }
  .selected {
    border: 2px solid black;
  }
}
</style>
